// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rXZr","left":"styles_left__22VpH"};